import $ from 'jquery';
import _ from 'underscore';
import { queryify } from '@bingads-webui/url-util';
import state from '@bingads-webui-component-legacy/state/index';
import $http from '@bingads-webui-component-legacy/http/channel/core';

const exclusionUrl = '/Campaign/campaigns/BulkUpdate';

function getUrl() {
  return queryify(exclusionUrl, {
    cid: state.get('customer_id'),
    uid: state.get('user_id'),
    aid: state.get('account_id'),
    __adcenterAJAX: 'true',
  });
}

export function exclusionsUpdate(data) {
  return $http.post(getUrl(), {
    contentType: 'application/x-www-form-urlencoded',
    'data': _.defaults({
      __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
      'CampaignsGrid.Action': 'BulkAction',
    }, data),
  });
}
